import React, {Suspense, useCallback, useRef, useState} from 'react';
import {Vector3, Quaternion, Box3, Mesh} from 'three';
import {useARStore} from 'stores';

import ARModelLoader from './AR.Model.Loader';
import ARModelShadowPlane from './AR.Model.ShadowPlane';
import ARModelDimension from './AR.Model.Dimension';

import ARModelGLB from './AR.Model.GLB';
import ARModelGLTF from './AR.Model.GLTF';
// import ARModelFBX from './AR.Model.FBX';
// import ARModelOBJ from './AR.Model.OBJ';

export const DEFAULT_MODEL_TRANSFORM: ARModel.TransformType = {
  position: new Vector3(),
  quaternion: new Quaternion(),
  scale: new Vector3(1, 1, 1),
};

namespace ARModel {
  export type TransformType = {
    position: Vector3;
    quaternion: Quaternion;
    scale: Vector3;
  };
}

interface IARModelProps {
  model: useARStore.ModelType;
  modelActive: useARStore.ModelActiveType;
}

const ARModel = React.memo(({model, modelActive}: IARModelProps) => {
  const {id, data, transform: rawTransform} = model;
  const transform = rawTransform || DEFAULT_MODEL_TRANSFORM;
  const [meshSize, setMeshSize] = useState(new Vector3());

  const meshRef = useRef<Mesh>(null);
  const isActive = model.id === modelActive.id;

  const handleCalcSize = useCallback(() => {
    if (meshRef.current) {
      const size = new Vector3();
      const boundingBox = new Box3().setFromObject(meshRef.current);
      boundingBox.getSize(size);
      setMeshSize(size);
    }
  }, [setMeshSize]);

  return (
    <Suspense fallback={<ARModelLoader position={transform.position} />}>
      <group
        ref={isActive ? modelActive.ref : null}
        userData={{id}}
        position={transform?.position}
        quaternion={transform?.quaternion}
        scale={transform?.scale}>
        <ARModelShadowPlane meshSize={meshSize} />
        <ARModelDimension meshSize={meshSize} visible={isActive} />
        <mesh ref={meshRef}>
          {(() => {
            if (data.fileFormat === 'glb') {
              return <ARModelGLB data={data} onLoad={handleCalcSize} />;
            }
            if (data.fileFormat === 'gltf') {
              return <ARModelGLTF data={data} onLoad={handleCalcSize} />;
            }
            // if (data.fileFormat === 'fbx') {
            //   return <ARModelFBX data={data} onLoad={handleCalcSize} />;
            // }
            // if (data.fileFormat === 'obj') {
            //   return <ARModelOBJ data={data} onLoad={handleCalcSize} />;
            // }
          })()}
        </mesh>
      </group>
    </Suspense>
  );
});

export default ARModel;
